import InviteToMoveInInvitationModal from './InviteToMoveInInvitationModal';
export default InviteToMoveInInvitationModal;
